package br.com.vvrefeicoes.portal.core.util.spreadsheet

/**
 * Abre o seletor de arquivo da plataforma e devolve a planilha importada como uma grade de
 * strings (primeira linha = cabeçalho). Retorna `null` se o usuário cancelar ou a plataforma
 * não suportar a importação.
 */
expect suspend fun pickSpreadsheetGrid(): List<List<String>>?

/** `true` quando a plataforma implementa a importação de planilha (CSV/XLSX). */
expect fun isSpreadsheetImportSupported(): Boolean

data class PickedSpreadsheet(
    val fileName: String,
    val rows: List<List<String>>,
)

/**
 * Abre o seletor de `.xlsx` e lê a aba de fechamento de compras (nome contendo "fech").
 * Retorna `null` se o usuário cancelar ou a plataforma não suportar a seleção.
 */
expect suspend fun pickPurchasesSpreadsheet(sheetNameContains: String? = null): PickedSpreadsheet?
